import "./Saidi.css";
import React, { useMemo, useState } from "react";
import DynamicModal from "../../components/Modal/DynamicModal";
import SaidiModalContent from "./SaidiModalContent";

const Saidi = ({ wfsLayers, clickInfo, selectedFeature }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const flatSelectedFeatures = useMemo(() => {
        if (!Array.isArray(selectedFeature)) return [];
        return selectedFeature.flat().filter(Boolean);
    }, [selectedFeature]);

    const selectedVodOrDionica = useMemo(() => {
        return (
            flatSelectedFeatures.find((feature) => {
                const featureId = feature?.id || "";
                return featureId.includes("vod") || featureId.includes("dionica");
            }) || null
        );
    }, [flatSelectedFeatures]);

    const selectedTrafo = useMemo(() => {
        return (
            flatSelectedFeatures.find((feature) => {
                const featureId = feature?.id || "";
                return featureId.includes("trafo_stanice");
            }) || null
        );
    }, [flatSelectedFeatures]);

    const clickedFeature = useMemo(() => {
        if (!clickInfo) return null;

        const layerId = clickInfo?.layer?.id || "";
        const objectId = clickInfo?.object?.id || "";

        if (
            layerId.includes("vod") ||
            layerId.includes("dionica") ||
            layerId.includes("trafo_stanice") ||
            objectId.includes("vod") ||
            objectId.includes("dionica") ||
            objectId.includes("trafo_stanice")
        ) {
            return clickInfo;
        }

        return null;
    }, [clickInfo]);

    const clickedVodOrDionica = useMemo(() => {
        const layerId = clickedFeature?.layer?.id || "";
        const objectId = clickedFeature?.object?.id || "";

        if (
            layerId.includes("vod") ||
            layerId.includes("dionica") ||
            objectId.includes("vod") ||
            objectId.includes("dionica")
        ) {
            return clickedFeature;
        }

        return null;
    }, [clickedFeature]);

    const clickedTrafo = useMemo(() => {
        const layerId = clickedFeature?.layer?.id || "";
        const objectId = clickedFeature?.object?.id || "";

        if (layerId.includes("trafo_stanice") || objectId.includes("trafo_stanice")) {
            return clickedFeature;
        }

        return null;
    }, [clickedFeature]);

    const activeVodOrDionica = selectedVodOrDionica || clickedVodOrDionica;
    const activeTrafo = selectedTrafo || clickedTrafo;

    const vodFeatureId = useMemo(() => {
        return activeVodOrDionica?.object?.id || activeVodOrDionica?.id || null;
    }, [activeVodOrDionica]);

    const vodDisplayId = useMemo(() => {
        if (!vodFeatureId) return null;
        return vodFeatureId.split(".")[1] || vodFeatureId;
    }, [vodFeatureId]);

    const pripadnostVodu = useMemo(() => {
        return (
            activeVodOrDionica?.object?.properties?.pripadnost_vodu ??
            activeVodOrDionica?.properties?.pripadnost_vodu ??
            null
        );
    }, [activeVodOrDionica]);

    const trafoNaziv = useMemo(() => {
        return (
            activeTrafo?.object?.properties?.naziv ??
            activeTrafo?.properties?.naziv ??
            null
        );
    }, [activeTrafo]);

    const trafoId = useMemo(() => {
        const rawId = activeTrafo?.object?.id || activeTrafo?.id || null;
        if (!rawId) return null;
        return rawId.split(".")[1] || rawId;
    }, [activeTrafo]);

    const canOpenModal = !!(activeVodOrDionica || activeTrafo);

    return (
        <div className="saidi-panel-div">
            <div className="saidi-header">
                <h3>SAIDI</h3>
            </div>

            <div className="saidi-body">
                {canOpenModal ? (
                    <>
                        <div className="saidi-status success">
                            {pripadnostVodu
                                ? `Vod izabran${vodDisplayId ? ` • ${vodDisplayId}` : ""} • ${pripadnostVodu}`
                                : trafoNaziv
                                    ? `Izabrana trafostanica${trafoId ? ` • ${trafoId}` : ""} • ${trafoNaziv}`
                                    : "Izabran objekat za SAIDI"}
                        </div>

                        <button
                            type="button"
                            className="saidi-open-btn"
                            onClick={openModal}
                        >
                            Prikaži podatke
                        </button>
                    </>
                ) : (
                    <div className="saidi-status warning">
                        Nije izabran nijedan vod.
                    </div>
                )}
            </div>

            <DynamicModal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                title="SAIDI"
                mainContent={
                    <SaidiModalContent
                        wfsLayers={wfsLayers}
                        clickInfo={clickInfo}
                        selectedFeature={selectedFeature}
                    />
                }
                footerContent={
                    <button onClick={closeModal} className="app-btn app-btn-secondary">
                        Zatvori
                    </button>
                }
                customHeight="85vh"
                customWidth="75vw"
                customZIndex={1000}
            />
        </div>
    );
};

export default Saidi;